
jQuery(document).ready(function ($) {
    var target = document.getElementById("qrcode");
    if (!target) return;
    new QRCode(target, window.location.href);
});